import React, { useContext } from 'react'
import { Context } from '../components/common/BaseContext'

export function useCustomModal(component, styles) {
    const { setCustomModalComponent } = useContext(Context)

    function showModal(props) {
        const content = React.isValidElement(component) ? React.cloneElement(component, props) : component(props)
        setCustomModalComponent({ content, styles })
    }

    function hideModal() {
        setCustomModalComponent(null)
    }

    return [showModal, hideModal]
}
